const INIT_STATE = {
    isModalActive: false
  }
  
  export function LogoutModalReducer(state=INIT_STATE, action) {
    switch (action.type) {
      case 'LOGOUT_MODAL_RESET':
        return {...INIT_STATE};
      case 'LOGOUT_MODAL_SHOW':
        return {...state, isModalActive: true};
      case 'LOGOUT_MODAL_HIDE':
        return {...state, isModalActive: false};
      case 'LOGOUT_MODAL_TOGGLE':
        return {...state, isModalActive: !state.isModalActive};
      default:
        return state;
    }
  }
  